import { useCalendarTaskSync as _useCalendarTaskSync } from '@griply/hooks';
import { CalendarTaskSync, Task } from '@griply/types';
import { useGoals } from 'features/goals';

import { useExternalCalendarConnections } from './use-external-calendar-connections';
import { useSetTaskCalendarOverride } from './use-set-task-calendar-override';

export const useCalendarTaskSync = (tasks: Task[]): CalendarTaskSync => {
  const connections = useExternalCalendarConnections();
  const goals = useGoals();
  const setTaskOverride = useSetTaskCalendarOverride();

  return _useCalendarTaskSync(tasks, { connections, goals, setTaskOverride });
};
